import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import apiClient from "../utils/apiClient";
import config from "../utils/config";

interface LabMemberState {
  labMembers: any[];
  loading: boolean;
  error: string | null;
}

const initialState: LabMemberState = {
  labMembers: [],
  loading: false,
  error: null,
};

export const getAllLabMembers = createAsyncThunk(
  "labMember/getLabMembers",
  async (_, thunkAPI) => {
    try {
      const response = await apiClient.get(
        `${config.services.ums}/api/v1/lab-users`
      );
      return response.data;
    } catch (error: AxiosError | any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const LabMemberSlice = createSlice({
  name: "labMember",
  initialState,
  reducers: {
    resetLabMemberState: (state) => {
      state.labMembers = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllLabMembers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllLabMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.labMembers = action.payload.data || [];
      })
      .addCase(getAllLabMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetLabMemberState } = LabMemberSlice.actions;

export default LabMemberSlice.reducer;